import { render, staticRenderFns } from "./image-upload-model.vue?vue&type=template&id=05ca42b4&scoped=true&"
import script from "./image-upload-model.vue?vue&type=script&lang=js&"
export * from "./image-upload-model.vue?vue&type=script&lang=js&"
import style0 from "./image-upload-model.vue?vue&type=style&index=0&id=05ca42b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca42b4",
  null
  
)

component.options.__file = "image-upload-model.vue"
export default component.exports